import React from 'react';
import PropTypes from 'prop-types';
import { Button, Icon, Flex } from 'roo-ui/components';

const IconButton = ({ icon, iconSize, children, ...rest }) => {
  const iconSpacer = children ? { mr: 2 } : {};
  return (
    <Button {...rest}>
      <Flex alignItems="center" justifyContent="center">
        <Icon name={icon} size={iconSize} {...iconSpacer} />
        {children}
      </Flex>
    </Button>
  );
};

IconButton.defaultProps = {
  icon: 'report',
  iconSize: 24,
};

IconButton.propTypes = {
  icon: PropTypes.string,
  iconSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.node.isRequired,
};

export default IconButton;
